// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t6B6","icon":"styles_icon__1oc0G"};